import { PlayArrowRounded } from "@mui/icons-material";
import FullWidthButton from "./FullWidthButton";
import { episodePlaybackLabel } from '../utils/episodePlaybackLabel';
import './EpisodePlaybackGlass.css';



const ContinueListeningButton = ({ continueListening, totalSeconds, startSeconds, horizontalPadding = '20px' }) => {
  const label = episodePlaybackLabel(totalSeconds, startSeconds, true);
  return (
    <FullWidthButton
      Icon={PlayArrowRounded}
      title={label.title}
      accessibilityLabel={label.accessibilityLabel}
      onClick={continueListening}
      showChevron={false}
      buttonClassName='episodePlaybackGlass'
      containerPadding={`6px ${horizontalPadding}`}
      contentGap='10px'
      iconStyle={{ fontSize: '18px', verticalAlign: 'middle' }}
    />
  );
};

export default ContinueListeningButton;
